import { ActionReducer, MetaReducer } from '@ngrx/store';
import { CoreContextEffects } from './core/store/core-context/core-context-effects';
import { MemberEffects } from './core/store/member/member-effects';
import { OffersEffects } from '@app/core/store/offers/offers-effects';
import { GamesEffects } from '@app/core/store/games/games-effects';
import { SpaycialIntegrationEffects } from '@app/core/store/spaycial-integration/spaycial-integration-effects';
import { LegalDocumentsEffects } from '@app/core/store/legal-documents/effects';
import { ProgramsEffects } from '@app/core/store/programs/effects';
import { environment } from '../environments/environment';

export const STORE_EFFECTS = [
  CoreContextEffects,
  MemberEffects,
  OffersEffects,
  GamesEffects,
  SpaycialIntegrationEffects,
  LegalDocumentsEffects,
  ProgramsEffects,
];

export function storeDebug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (environment.debugMode) {
      console.log('[STORE] pre state', state);
      console.log('[STORE] action', action);
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [
  storeDebug,
];
